import { showWooCommerceNotices, noticeFailure, noticeSuccess } from "@self/notices";
import { bound, CustomElement, customElement } from "../CustomElement";

@customElement("gct-apply-coupon")
export class ApplyCoupon extends CustomElement {

	input: HTMLInputElement;
	button: HTMLButtonElement;

	static get observedAttributes() {
		return ["value"] as const;
	}

	constructor() {
		const button = (
			<button type="button" className="gct-btn-lg gct-btn-secondary">
				Apply
			</button>
		) as HTMLButtonElement;

		const input = <input
			type="text"
			className="gct-w100"
			placehodler="Enter discount code"
		/> as HTMLInputElement;

		super(
			<div className="gct-flex-row gct-gap-16 gct-flex-space-between">
				{input}
				{button}
			</div>
		);

		this.input = input;
		this.button = button;

		input.value = this.getAttribute("value") ?? "";
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}

	@bound
	async onClick() {
		try {
			this.button.disabled = true;
			this.input.disabled = true;

			const couponCode = this.input.value;

			const data = new URLSearchParams({
				apply_coupon: "Apply coupon",
				coupon_code: couponCode,
				"woocommerce-cart-nonce": this.dataset.nonce!,
			});

			const res = await fetch(this.dataset.endpoint!, {
				method: "POST",
				body: data,
				credentials: "include",
			});

			const html = await res.text();
			const newDocument = new DOMParser().parseFromString(html, "text/html");
			document.body.innerHTML = newDocument.body.innerHTML;

			/* VOLATILE When we completely replace document's innerHTML, we must
			 * show notices AFTER, not before we do that.
			 */
			const notices = newDocument.getElementById("gct-notices");
			if (notices !== null) {
				showWooCommerceNotices(notices);
			}
		} catch (error) {
			if (error instanceof TypeError) {
				noticeFailure("Couldn't connect. Are you online?");
			} else {
				noticeFailure("There was an unexpected error.")
			}
		} finally {
			this.button.disabled = false;
			this.input.disabled = false;
		}
	}
}
